export default "__VITE_ASSET__CvwcqsMz__"